// Code for the TextButton component
import React from 'react';
import './TextButton.css';

const TextButton = ({ onClick, text}) => {
    return (
        <button className="text-button" onClick={onClick}>{text}</button>
    );
};

export default TextButton;
